// extracted by mini-css-extract-plugin
module.exports = {"select":"BwStatsHeader_select__36_wi","selectContainer":"BwStatsHeader_selectContainer__1_YPq"};